import { useEffect } from 'react';

import { initializeScrollListener } from '../utils/initializeScrollListener';

/**
 * Hook that initializes the scroll listener and handles cleanup automatically.
 * This hook sets up the scroll position tracking and header visibility logic.
 */
export const useSetupScrollPositionStore = (): void => {
  useEffect(() => {
    const cleanup = initializeScrollListener();
    return cleanup;
  }, []);
};
